import { Cloud } from '@cast/shared-types';
import { CloudAssetIntegrationsScope } from '@cast/types-inventory';

export const canCommitmentsBeAutoEnabledForAutoscaling = (
  provider: Cloud,
  scope: CloudAssetIntegrationsScope | undefined
): boolean => {
  if (
    provider === Cloud.aws ||
    provider === Cloud.azure ||
    provider === Cloud.gcp
  ) {
    return (
      scope === CloudAssetIntegrationsScope.ALL ||
      scope === CloudAssetIntegrationsScope.ALL_MINIMAL_PERMISSIONS
    );
  }
  return false;
};
